<template>
    <Teleport to="body">
        <Transition
            :name="transition"
            :duration="{ enter: 300, leave: 300 }"
        >
            <div
                v-if="isShow"
                class="an-layer"
                v-bind="$attrs"
            >
                <div class="an-layer-mask" @click="maskClick"></div>
                <div class="an-layer-container" :class="transition">
                    <slot :action="{ hide }"></slot>
                </div> 
            </div>
        </Transition>
    </Teleport>
</template>

<script>
export default {
    emits: ['displayChange', 'after-enter', 'after-leave'],
    props: {
        // 动画形式
        transition: {
            type: String,
            default: 'fade-in'
        },
        // 是否展示, 修改这个值会触发显示隐藏
        isShow: {
            type: Boolean
        },
        // 当点击遮罩时是否隐藏, 默认true
        hideOnClickMask: {
            type: Boolean,
            default: () => true
        },
    },
    methods: {
        show() {
            this.$emit('displayChange', true)
        },
        hide() {
            this.$emit('displayChange', false)
        },
        maskClick() {
            console.log('asdasdmaskclick')
            if (this.hideOnClickMask) {
                this.hide();
            }
        },
        handleAfterEnter() {
            this.$emit('after-enter');
        },
        handleAfterLeave() {
            // this.doDestroy();
            this.$emit('after-leave');
        }
    }
};
</script>

<style lang="scss">
.an-layer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: calc(var(--level-subhigh) - 1); // same as pop-mask
    .an-layer-mask{
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(25, 25, 25, 0.6);
        transition: opacity 0.3s ease;
    }
    .an-layer-container{
        position: absolute;
        max-width: 100%;
        transition: all 0.3s ease;
        display: inline-block;
        z-index: 1;
    }
}

.fade-in-enter-from .an-layer-mask,
.fade-in-leave-to .an-layer-mask,
.right-in-enter-from .an-layer-mask,
.right-in-leave-to .an-layer-mask,
.fade-in-enter-from .an-layer-container,
.fade-in-leave-to .an-layer-container {
    opacity: 0;
}


.right-in.an-layer-container{
    right: 0;
}
.right-in-enter-from .an-layer-container,
.right-in-leave-to .an-layer-container {
    transform: translate3d(100%, 0, 0);
}


</style>
